import { useEffect, useState } from "react";
import { buscarAnuncioPropriedeByCotaUsuario } from "../../../services/buscarAnuncioPropriedeByCotaUsuarioService";

export const useAnuncioPropriedade = (
  cotaUsuarioId: number | null,
  isModalOpen: boolean
) => {
  const [anuncioPropriedade, setAnuncioPropriedade] = useState<any | null>(
    null
  );
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetch = async () => {
      if (cotaUsuarioId && isModalOpen) {
        setLoading(true);
        try {
          const data = await buscarAnuncioPropriedeByCotaUsuario(cotaUsuarioId);
          if (data) {
            setAnuncioPropriedade(data[0]);
            console.log("Anuncio propriedade:", data[0]);
          }
        } catch (err) {
          console.error("Erro ao buscar anuncio propriedade:", err);
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    };

    fetch();
  }, [cotaUsuarioId, isModalOpen]);

  return { anuncioPropriedade, loading };
};
